import api from './api';

const managementRequest = (storeId, params) => ({
  params,
  paramsSerializer: { indexes: null },
  _authContext: 'management',
  _storeId: storeId,
});

export const getDashboardInsights = async (storeId, { period, teamMemberIds }) => {
  const response = await api.get(`/stores/${storeId}/dashboard/insights`, managementRequest(storeId, { period, teamMemberIds }));
  return response.data;
};

export const getDashboardPeakTimes = async (storeId, { teamMemberIds }) => {
  const response = await api.get(`/stores/${storeId}/dashboard/peak-times`, managementRequest(storeId, { teamMemberIds }));
  return response.data;
};

export const getDashboardRecent = async (storeId) => {
  const response = await api.get(`/stores/${storeId}/dashboard/recent`, managementRequest(storeId));
  return response.data;
};

export const getDashboardNewCustomers = async (storeId, { days }) => {
  const response = await api.get(`/stores/${storeId}/dashboard/customers/new`, managementRequest(storeId, { days }));
  return response.data;
};

export const getDashboardReturnRate = async (storeId, { days, ignoreInactive }) => {
  const response = await api.get(`/stores/${storeId}/dashboard/customers/return-rate`, managementRequest(storeId, { days, ignoreInactive }));
  return response.data;
};

export const getDashboardNewCustomerReturnRate = async (storeId, { days }) => {
  const response = await api.get(`/stores/${storeId}/dashboard/customers/new-return-rate`, managementRequest(storeId, { days }));
  return response.data;
};

export const rebuildStoreDashboard = async (storeId) => {
  await api.post(`/stores/${storeId}/dashboard/rebuild`, null, {
    _authContext: 'management',
    _storeId: storeId,
  });
};

const dashboardService = {
  getDashboardInsights,
  getDashboardPeakTimes,
  getDashboardRecent,
  getDashboardNewCustomers,
  getDashboardReturnRate,
  getDashboardNewCustomerReturnRate,
  rebuildStoreDashboard,
};

export default dashboardService;
